<template>
    <SubmenuGrid :items="items" :show-count="false" />
</template>

<script>
import SubmenuGrid from "@/components/SubmenuGrid";

export default {
    name: "PortalSchoolCareerAndGuidanceSubMenuvueSubmenu",
    components: { SubmenuGrid },
    data() {
        return {
            items: [
            {
                to: "#",
                title: "Career Counseling",
                description: "Record counseling sessions and support student career choices.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Internship",
                description: "Manage internship placements and student participation.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Job Opportunities",
                description: "Share career opportunities with students and graduates.",
                icon: "fa fa-folder"
            }
            ]
        };
    }
};
</script>
